import React from 'react';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { TabListProps } from '@chakra-ui/react';

type Props = {
  [x: string]: any,
  children: React.ReactNode,
} & TabListProps;

export default function CustomTabList({ children, ...rest }: Props) {
  return (
    <>
      <CC.TabList {...rest}>{children}</CC.TabList>
    </>
  );
}
